export class TranslationConstants {
  // global
  public static GLOBAL_ERROR = 'global.error';
  public static GLOBAL_SERVER_ERROR = 'global.error.server_error';
  public static GLOBAL_CANCEL_MODAL_MESSAGE = 'global.cancel_modal.message';
  public static GLOBAL_ALERT_SWITCH_CONTAINER_CONTENT = 'global.alert_switch_container_content';
  public static GLOBAL_ALERT_SWITCH_CONTAINER = 'global.alert_switch_container';
  public static GLOBAL_SWITCH_CONTAINER = 'global.switch_container';
  public static GLOBAL_SWITCH_CONTAINER_CONTENT = 'global.switch_container_content';
  public static GLOBAL_YES = 'global.yes';
  public static GLOBAL_NO = 'global.no';
  public static GLOBAL_LEAVE = 'global.leave';
  public static GLOBAL_LEAVE_CONTENT = 'global.leave_content';
  public static GLOBAL_CODE = 'global.code';
  public static GLOBAL_ID = 'global.id';
  public static GLOBAL_CONFIRM = 'global.confirm';
  public static GLOBAL_ENTITY = 'global.entity';
  public static GLOBAL_MNE = 'global.mne';
  public static GLOBAL_TRANSACTION = 'global.transaction';
  public static GLOBAL_ENTITIES = 'global.entities';
  public static GLOBAL_MNES = 'global.mnes';
  public static GLOBAL_TRANSACTIONS = 'global.transactions';
  public static GLOBAL_REINITIALIZE = 'global.reinitialize';
  public static GLOBAL_REINITIALIZE_WARNING = 'global.reinitialize_warning';
  public static GLOBAL_REINITIALIZE_FIONA_DEFAULT = 'global.reinitialize_fiona_default';
  public static GLOBAL_REINITIALIZE_FIONA_DEFAULT_WARNING = 'global.reinitialize_fiona_default_warning';
  public static GLOBAL_UNCONTROLLED_TRANSACTIONS = 'global.uncontrolled_transactions';
  public static GENERAL_UNCONTROLLED_ABBREV = 'general.uncontrolled_abbrev';
  public static GENERAL_CURRENT_TBA = 'global.current_tba';
  // comparability
  public static DETERMINE_ACCEPTANCE_CLOSE_TITLE = 'determine_acceptance.cancel_modal.title';
  // range results
  public static DISCUSS_RANGE_RESULT_CLOSE_TITLE = 'range_result.cancel_modal.title';
  // transactions

  // UPE
  public static UPE_ID_MISSING = 'upe.upe_id_missing';
  public static UPE_ID_MISSING_MESSAGE = 'upe.upe_id_missing_message';

  public static TRANSACTION_TANGIBLE_GOODS = 'transaction.tangible_goods';
  public static TRANSACTION_INTANGIBLE_GOODS = 'transaction.intangible_goods';
  public static TRANSACTION_SERVICES = 'transaction.services';
  public static TRANSACTION_LOANS = 'transaction.loans';
  public static TRANSACTION_CLOSE_TITLE = 'transaction.close_modal_title';
  public static TRANSACTION_TRANSACTIONS_DIRECTORY = 'transaction.transaction_directory';
  public static CLOSE_SERVICE_EVALUATION = 'transaction.close_evaluation_modal_title';
  public static CLOSE_ADD_NEW_SUBTOPIC = 'background_info.close_add_new_subtopic';
  public static COPY_TRANSACTION_FUNCTIONAL_ANALYSIS = 'functional_analysis.copy_complete_functional_analysis';
  public static COPY_TRANSACTION_FUNCTIONAL_ANALYSIS_WARNING =
    'functional_analysis.copy_transaction_functional_analysis_warning';
  // background info tabs
  public static BACKGROUND_INFO_COPY_WARNING = 'background_info.copy_warning';
  public static BACKGROUND_INFO_TEMPLATE_IMPORT_MODAL_TITLE = 'background_info.template_import_modal_title';
  public static BACKGROUND_INFO_TEMPLATE_IMPORT_MODAL_WARNING = 'background_info.template_import_modal_warning';
  // functional analyses
  public static FUNCTIONAL_ANALYSES_DELETE_CHARACTERISTIC = 'functional_analyses.delete_characteristic';
  public static FUNCTIONAL_ANALYSES_DELETE_CHARACTERISTIC_CONFIRM = 'functional_analyses.delete_characteristic_confirm';
  public static FUNCTIONAL_ANALYSES_CLOSE_CHARACTERISTIC_CONFIRM = 'functional_analyses.close_characteristic_confirm';
  // PBA
  public static PBA_DELETE_TITLE = 'pba.delete';
  public static PBA_CONFIRM_DELETE = 'pba.confirm_delete';
  public static PBA_REMOVE_TRANSACTION_CONFIRM = 'pba.remove_transaction_confirm';
  public static NO_SUITABLE_TRANSACTIONS = 'pba.no_suitable_transactions';
  // errors
  public static ERROR_PBA_TRADING_PAIR = 'error_message.pba_cannot_add_trading_pair';
  public static ERROR_PBA_TRANSACTION_ID = 'error_message.pba_transaction_id';
  public static ERROR_IMPORT_NO_MAPPING = 'error_message.import_no_mapping';
  public static ERROR_IMPORT_FIELD_INVALID = 'error_message.import_field_invalid';
  public static ERROR_CONVERSIONS_VALUES = 'error_message.currency_conversion_values_invalid';
  public static ERROR_FILE_TYPE_INVALID = 'error_message.file_type_invalid';
  public static ERROR_NO_DESCRIPTION = 'error_message.please_enter_description';
  public static ERROR_COUNTRY_OR_REGION_IS_REQUIRED = 'error_message.country_or_region_is_required';
  public static ERROR_SIC_CODE_MIN_IS_REQUIRED = 'error_message.sic_code_min_is_required';
  public static ERROR_SIC_CODE_MAX_IS_REQUIRED = 'error_message.sic_code_max_is_required';
  public static ERROR_MAX_SIC_MUST_BE_GREATER_THAN_MIN_SIC = 'error_message.max_sic_must_be_greater_than_min_sic';
  public static ERROR_MAX_TINYMCE_FILESIZE_EXCEEDED = 'The data could not be saved as it exceeds the 4 megabyte limit. Please remove some data and try saving again.';
  public static ERROR_IMPORT_INVALID_COLUMN_NAME = 'error_message.import_invalid_column_name';
  public static ERROR_IMPORT_MISMATCH_COLUMNS = 'error_message.import_mismatch_columns';
  // modals
  public static MODAL_TITLE_CLOSE_ADD_TRANSACTIONS = 'modals.close_add_transactions';
  // study and related
  public static STUDY_REMOVE_TRANSACTION = 'study.remove_transaction'; // can be reused for study/TBA/PBA
  // tested party
  public static TESTED_PARTY_CHANGE_PRIMARY_FUNCTION = 'tested_party.change_primary_function';
  // currency scale
  public static CURRENCY_SCALE_FULL_VALUE = 'currency_scale.full_value';
  public static CURRENCY_SCALE_HUNDREDTHS = 'currency_scale.hundredths';
  public static CURRENCY_SCALE_THOUSANDTHS = 'currency_scale.thousandths';
  public static CURRENCY_SCALE_TEN_THOUSANDS = 'currency_scale.ten_thousands';
  public static CURRENCY_SCALE_HUNDRED_THOUSANDS = 'currency_scale.hundred_thousands';
  public static CURRENCY_SCALE_MILLIONTHS = 'currency_scale.millionths';
  public static CURRENCY_SCALE_TEN_MILLIONTHS = 'currency_scale.ten_millionths';
  public static CURRENCY_SCALE_HUNDRED_MILLIONTHS = 'currency_scale.hundred_millionths';

  public static DELETE_COMPARABLE_POOL = 'comp_search.delete_comparable_pool';
  public static DELETE_COMPARABLE_POOL_MESSAGE = 'comp_search.delete_comparable_pool_message';

  // report generation
  public static REPORT_GENERATION_COMPLETE = 'report_generation.complete';
  public static REPORTS_GENERATED_FOR_ENTITIES = 'report_generation.complete_for_entities';
  public static REPORT_GENERATION_ERROR_NO_SELECTED_ENTITIES = 'error_message.report_generation_no_entities_selected';
  public static REPORT_GENERATION_ERROR_NO_SELECTED_TEMPLATE = 'error_message.report_generation_no_template_selected';
  public static REPORT_GENERATION_REPORT_TITLE_REQUIRED = 'error_message.report_generation_report_title_required';
  public static REPORT_GENERATION_REPORT_DOUBLE_QUOTES = 'error_message.report_generation_report_title_double_quotes';
  public static REPORT_GENERATION_ERROR_NO_CURRENCY_SELECTED = 'error_message.report_generation_no_currency_selected';
  public static REPORT_GENERATION_ERROR_TEMPLATE_MUST_BE_SELECTED = 'error_message.template_must_be_selected';
  public static REPORT_GENERATION_ERROR_STAGE_MUST_BE_SELECTED = 'error_message.stage_must_be_selected';
  public static REPORT_GENERATION_ERROR_LANGUAGE_MUST_BE_SELECTED = 'error_message.language_must_be_selected';
  // tslint:disable-next-line:max-line-length
  public static REPORT_GENERATION_ERROR_EXECUTIVE_SUMMARY_INTRO_MISSING = 'error_message.executive_summary_missing_intro';
  // tslint:disable-next-line:max-line-length
  public static REPORT_GENERATION_ERROR_EXECUTIVE_SUMMARY_CONCLUSION_MISSING = 'error_message.executive_summary_missing_conclusion';
  // Tested Party Major and Minor classification
  public static MAJOR_CLASSIFICATION_MAX_3_ERROR = 'error_message.major_service_classification_max_3';
  public static MAJOR_CLASSIFICATION_REQUIRED = 'error_message.major_service_classification_required';
  public static MINOR_CLASSIFICATION_REQUIRED = 'error_message.minor_service_classification_required';
  // tslint:disable-next-line:max-line-length
  public static REPORT_GENERATION_ERROR_NO_TRADING_PARTNER_SELECTED = 'error_message.report_generation_no_trading_partner_selected';
  public static REPORT_GENERATION_ERROR_NO_PRIMARY_ENTITY_SELECTED = 'error_message.primary_entity_required';
  // tslint:disable-next-line:max-line-length
  public static REPORT_GENERATION_ERROR_NO_TRANSACTIONS_SELECTED = 'error_message.report_generation_no_transactions_selected';

  public static WORKING_REPORT_REPOSITORY_DELETE_REPORT_CONFIRMATION_TEXT = 'working_report_repository.delete_report_confirmation_text';

  public static WORKING_REPORT_REPOSITORY_DELETE_REPORT_VERSION_CONFIRMATION_TEXT = 'working_report_repository.delete_report_version_confirmation_text';

  public static WORKING_REPORT_REPOSITORY_DELETE_REPORT = 'working_report_repository.delete_report';

  public static WORKING_REPORT_REPOSITORY_DELETE_REPORT_VERSION = 'working_report_repository.delete_report_version';
}
